const normalizeRoleName = (user) => (user?.roleName || user?.nombreRol || user?.role || '').toLowerCase().trim();

const isAdminRegional = (user) => {
  const roleName = normalizeRoleName(user);
  return roleName === 'adminregional'
    || roleName === 'admin regional'
    || roleName.includes('adminregional')
    || roleName.includes('admin regional')
    || roleName.includes('admin del regional');
};

const isAdminArea = (user) => {
  const roleName = normalizeRoleName(user);
  return roleName === 'adminarea'
    || roleName === 'admin area'
    || roleName.includes('adminarea')
    || roleName.includes('admin area');
};

const filterAdminMenuItems = (items, user) => {
  if (!Array.isArray(items)) return [];
  if (isAdminArea(user)) {
    const allowed = new Set(['profesores', 'materias', 'asistentes', 'asistentes-gpt', 'admin-area']);
    return items.filter((item) => allowed.has(item.id));
  }
  return items;
};

export { filterAdminMenuItems, isAdminRegional, isAdminArea };
